import React, { useEffect, useState } from 'react'

import {Link, NavLink, Route} from "react-router-dom";
import AdminReportRegList from './AdminReportRegList';
import AdminReportRegDietary from './AdminReportRegDietary';
import AdminReportRegHotel from './AdminReportRegHotel';
import AdminReportRegTravel from './AdminReportRegTravel';
import AdminReportRegContacts from './AdminReportRegContacts';
import AdminReportRegDocuments from './AdminReportRegDocuments';
import TopSubmenu from "~/Admin/Layout/TopSubmenu/TopSubmenu";
import {connect} from "react-redux";

const AdminReportReg = ({match, ...props}) => {

    return (
        <div className="data-uploads">

            <div className="row">
                <div className="col-8">
                    <h2>Registrations Report</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <TopSubmenu>
                        <NavLink
                            activeClassName="active"
                            exact
                            to={`${match.path}/`}>
                            Registrations
                        </NavLink>
                        <NavLink
                            activeClassName="active"
                            exact
                            to={`${match.path}/dietary`}>
                            Dietary
                        </NavLink>
                        <NavLink
                            activeClassName="active"
                            exact
                            to={`${match.path}/hotel`}>
                            Hotel Rooms
                        </NavLink>
                        <NavLink
                            activeClassName="active"
                            exact
                            to={`${match.path}/travel`}>
                            Travel
                        </NavLink>
                        <NavLink
                            activeClassName="active"
                            exact
                            to={`${match.path}/contact`}>
                            Emergency Contacts
                        </NavLink>
                        <NavLink
                            activeClassName="active"
                            exact
                            to={`${match.path}/documents`}>
                            Uploaded Documents
                        </NavLink>
                    </TopSubmenu>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12">
                    <Route exact path={`${match.path}/`} component={AdminReportRegList}/>
                    <Route exact path={`${match.path}/dietary`} component={AdminReportRegDietary}/>
                    <Route exact path={`${match.path}/hotel`} component={AdminReportRegHotel}/>
                    <Route exact path={`${match.path}/travel`} component={AdminReportRegTravel}/>
                    <Route exact path={`${match.path}/contact`} component={AdminReportRegContacts}/>
                    <Route exact path={`${match.path}/documents`} component={AdminReportRegDocuments}/>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminReportReg);
